// extracted by mini-css-extract-plugin
export default {"container":"wZ-z","list":"xZ-z"};